<script>
    export let user_data;
</script>

<div class="user-card" class:donor={user_data.donor}>
    <img src="https://mc-heads.net/avatar/{user_data.mc_uuid}/64" alt="">
    <span>{user_data.mc_name}</span>
</div>

<style>
    .user-card {
        border-radius: 5px;
        border: 1px solid #cacaca;
        padding: 12px;
    }

    .user-card img {
        vertical-align: middle;
        border-radius: 4px;
    }

    .user-card span {
        font-size: 18px;
        margin-left: 20px;
    }

    .user-card.donor span {
        font-weight: bold;
        color: #ffb300;
    }

    .user-card.donor {
        background-image: linear-gradient(to top right, #fff477, #fff);
        border-color: #ffcb70;
    }

    .user-card.donor img {
        opacity: .9;
    }
</style>